
/**
 * 정렬 정보
 */
export type TrendListResponsePageAllOfSort = {
  /** 정렬 정보 없음 여부 */
  empty?: boolean;
  /** 정렬됨 여부 */
  sorted?: boolean;
  /** 정렬 안됨 여부 */
  unsorted?: boolean;
};
